
import GcuLink from "@/components/gcuLink.vue";
import LocaleSwitcher from "@/components/LocaleSwitcher.vue";
import Loader from "@/components/Loader.vue";
import ContactCTAButtons from "@/components/ContactCTAButtons.vue";
import LinkCTAButtons from "@/components/LinkCTAButtons.vue";
import FullscreenButton from "@/components/buttons/FullscreenButton.vue";
import ARButton from "@/components/buttons/ARButton.vue";
import ShareButton from "@/components/buttons/ShareButton.vue";
import RGPDLink from "@/components/RGPDLink.vue";
import DownloadButton from "@/components/buttons/DownloadButton.vue";
import { ErrorStatus } from "@/typings/Error";
import {setPoster} from "@/services/PosterGenerator"

export default {
    name: "HomeContentClassic",
    components: {
        Loader,
        GcuLink,
        LocaleSwitcher,
        FullscreenButton,
        ARButton,
        ShareButton,
        ContactCTAButtons,
        LinkCTAButtons,
        RGPDLink,
        DownloadButton
    },
    emits: ["report-btn-clicked", "error"],
    props: {
        adminUrl: {
            type: String,
            default: ""
        },
        videoUrl: {
            type: String,
            default: ""
        },
        flipVideo: {
            type: Boolean,
            default: false
        },
        displayFullscreenButtons: {
            type: Boolean,
            default: true
        },
        displayRecordButton: Boolean,
        displayTextResponseButton: Boolean,
        displayEditButton: Boolean,
        displayShareButton: Boolean,
        displayDownloadButton: Boolean,
        displayArButton: Boolean,
        displayReportButton: {
            type: Boolean,
            default: true
        },
        goAr: {
            type: Function,
            required: true
        },
        onVideoPick: {
            type: Function,
            required: true
        },
        openReplyVideo: {
            type: Function,
            required: false
        },
        share: {
            type: Function,
            required: true
        },
        downloadVideo: {
            type: Function,
            required: true
        },
        contentBanned: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fullscreenEnabled: false,
            videoReady: false,
            isPlayingVideo: false,
            poster:""
        };
    },
    async mounted() {
        const videoHome = this.$refs.homeVideo as HTMLVideoElement;
        if (videoHome) {
            const timeout = setTimeout(() => {
                if (!this.videoReady) {
                    this.$emit("error", ErrorStatus.Timeout);
                }
            }, 15000);

            videoHome.oncanplay = () => {
                this.videoReady = true;
                clearTimeout(timeout);
            };

            videoHome.onerror = () => {
                this.$emit("error", ErrorStatus.LoadError);
                clearTimeout(timeout);
            };

            videoHome.removeEventListener("play", this.onVideoPlay);
            videoHome.removeEventListener("pause", this.onVideoStop);

            videoHome.addEventListener("play", this.onVideoPlay);
            videoHome.addEventListener("pause", this.onVideoStop);
            this.poster = await setPoster(videoHome);
        }
    },
    methods: {
        toggleFullscreen() {
            if (this.fullscreenEnabled) {
                this.exitFullScreen();
            } else {
                this.goFullScreen();
            }
        },
        goFullScreen() {
            const videoContainer = this.$refs.videoContainer;
            const boundingBox = videoContainer.getBoundingClientRect();

            this.fullscreenEnabled = true;
            document.documentElement.style.setProperty(
                "--fullscreenTopOffset",
                `${boundingBox.y}px`
            );
        },
        exitFullScreen() {
            this.fullscreenEnabled = false;
        },
        onVideoPlay() {
            this.isPlayingVideo = true;
        },
        onVideoStop() {
            this.isPlayingVideo = false;
        },
        togglePlay() {
            if (this.isPlayingVideo) {
                this.$refs.homeVideo.pause();
            } else {
                this.$refs.homeVideo.play();
            }
        }
    }
};
